// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const FolderRemoveIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "FolderRemove/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm4 6a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H8Z",
  clipRule: "evenodd"
}));
export default FolderRemoveIcon;